// This file was auto-generated by Fern from our API Definition.
export var TemplateLoadRequest;
(function (TemplateLoadRequest) {
    let UiOpPermissions;
    (function (UiOpPermissions) {
        UiOpPermissions.Value = {
            Allow: "allow",
            Ask: "ask",
        };
    })(UiOpPermissions = TemplateLoadRequest.UiOpPermissions || (TemplateLoadRequest.UiOpPermissions = {}));
})(TemplateLoadRequest || (TemplateLoadRequest = {}));
